import PublicNavbar from "../components/PublicNavbar";
import { Link } from "react-router-dom";
import { Video, Music, Megaphone, Palette } from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: Video,
      title: "Video Production",
      description: "High-definition music videos, commercials, and branded content that captivates audiences."
    },
    {
      icon: Music,
      title: "Music Promotion",
      description: "Strategic playlist placements, social media campaigns, and digital marketing for artists."
    },
    {
      icon: Megaphone,
      title: "Marketing & PR",
      description: "Full-service marketing campaigns, press releases, and brand visibility strategies."
    },
    {
      icon: Palette,
      title: "Creative Direction",
      description: "Concept development, art direction, and visual identity for your brand or release."
    }
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0B] relative overflow-hidden">
      <PublicNavbar />
      
      {/* Subtle background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/3 w-96 h-96 bg-[#D4AF37]/3 rounded-full blur-3xl"></div>
      </div>

      <main className="relative z-10 pt-32 pb-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h1 
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#FAFAFA] mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
              data-testid="services-title"
            >
              Our <span className="text-gold-gradient">Services</span>
            </h1>
            
            <p className="text-lg md:text-xl text-[#A1A1AA] max-w-2xl mx-auto" data-testid="services-description">
              Premium creative services designed to elevate your brand and amplify your reach.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="p-8 bg-[#121214] border border-[#27272A] rounded-xl hover:border-[#D4AF37]/50 transition-all duration-300 group"
                data-testid={`service-card-${index}`}
              >
                <div className="w-14 h-14 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mb-5 group-hover:bg-[#D4AF37]/30 transition-colors">
                  <service.icon size={28} className="text-[#D4AF37]" />
                </div>
                <h3 className="text-xl font-semibold text-[#FAFAFA] mb-3">{service.title}</h3>
                <p className="text-[#A1A1AA] text-sm leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center mt-16">
            <p className="text-[#A1A1AA] mb-6">Ready to take your project to the next level?</p>
            <Link 
              to="/promo" 
              className="inline-block px-8 py-3 bg-gradient-to-r from-[#D4AF37] to-[#B8952F] text-[#0A0A0B] font-semibold rounded-full hover:from-[#E5C558] hover:to-[#D4AF37] transition-all duration-300 shadow-lg hover:shadow-[#D4AF37]/20"
              data-testid="services-cta"
            >
              Start Your Campaign
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 text-center py-8 border-t border-[#27272A]">
        <p className="text-[#71717A] text-xs">
          © 2025 DopeInHD Incorporated. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Services;
